module.exports = __webpack_public_path__ + "img/tema-3-10.2801cf33.svg";